import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { runCalculateFeatures } from 'api/platform';

export const useRunCalculateFeaturesMutation = (
  options?: UseMutationOptions<unknown, unknown, Parameters<typeof runCalculateFeatures>[0]>
) => useMutation(runCalculateFeatures, options);
